import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { useStoreState } from 'easy-peasy';
import { isNull } from 'lodash';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import client from '../../../utils/apolloClient';

const deleteServiceMutation = gql`
  mutation deleteServiceMenu($input: NavigateMenuSectionInput) {
    delete_menu_section(input: $input) {
      menu_section_id
      name
      error {
        description
      }
    }
  }
`;

const GlobalMenuUpdate = ({ sectionId }) => {
  const { userId } = useStoreState(state => state.auth);

  return (
    <Mutation
      client={client.clientPrivate}
      mutation={deleteServiceMutation}
      onCompleted={({ delete_menu_section }) => {
        if (!isNull(delete_menu_section.error)) {
          delete_menu_section.error.map(item => toast.error(item.description));
        } else {
          toast.success('Menu Section deleted successfully!');
          window.location.reload(true);
        }
      }}
    >
      {(delete_menu_section, { loading }) => (
        <button
          disabled
          className={`button ${loading && 'is-loading'}`}
          onClick={() => {
            swal({
              title: 'Are you sure?',
              // eslint-disable-next-line max-len
              text: `Are you sure you want to delete this Menu Section`,
              buttons: ['Cancel', 'Yes'],
              dangerMode: true,
            }).then(willDelete => {
              if (willDelete) {
                delete_menu_section({
                  variables: {
                    input: {
                      user_id: userId,
                      menu_section_id: sectionId,
                    },
                  },
                });
              }
            });
          }}
        >
          <i className="fas fa-trash has-text-grey" />
        </button>
      )}
    </Mutation>
  );
};

export default GlobalMenuUpdate;
